<tt-form-field>
  <label for="treetop-code-input" ttLabel>{{ 'TreeTopCode' | transloco }}:</label>
  <input
    data-testid="editor-header_treetop-code-input"
    id="treetop-code-input"
    required
    ttInput
    [formControl]="code"
    (input)="handleInput()" />

  @if (code.errors?.exists) {
    <tt-error> {{ 'GuidelinesSection.Main.ExistingCodeError' | transloco }} </tt-error>
  } @else if (code.errors?.invalid === 'InvalidPrefix') {
    <tt-error> {{ 'GuidelineCodeMissing' | transloco }} </tt-error>
  } @else if (code.errors?.invalid === 'SpecialCharacterNotAllowed') {
    <tt-error> {{ 'SpecialCharacterNotAllowed' | transloco }} </tt-error>
  } @else if (code.invalid) {
    <tt-error> {{ 'GuidelineCodeMissing' | transloco }}. {{ 'GuidelinesSection.Main.HasToStartWithGL' | transloco }} </tt-error>
  }

  <tt-hint>{{ hintKey | transloco }}</tt-hint>
</tt-form-field>
